import { render, staticRenderFns } from "./demoPage.vue?vue&type=template&id=8ceecb2e&"
import script from "./demoPage.vue?vue&type=script&lang=js&"
export * from "./demoPage.vue?vue&type=script&lang=js&"
import style0 from "./demoPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports